import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function BottomBar({ role ,loggedIn}) {
  const [activeIcon, setActiveIcon] = useState("home");
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [initialHeight, setInitialHeight] = useState(window.innerHeight);

  const handleIconClick = (iconName) => {
    setActiveIcon(iconName);
  };

  useEffect(() => {
    // Update the initial height on mount.
    setInitialHeight(window.innerHeight);

    const handleResize = () => {
      // If the window's inner height shrinks significantly, assume the keyboard is open.
      if (window.innerHeight < initialHeight - 100) {
        setKeyboardOpen(true);
      } else {
        setKeyboardOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [initialHeight]);

  if (keyboardOpen) {
    // Hide the bottom bar when the keyboard is open.
    return null;
  }

  return (
    loggedIn && <div className="h-[7vh] md:hidden fixed bottom-0 left-0 w-full bg-white border-t border-gray-300 flex justify-around items-center p-3 shadow-lg z-50">
      {/* Home Icon */}
      {role === "admin" && (
        <Link to="/" onClick={() => handleIconClick("home")} className="relative group">
          <span className={`material-symbols-rounded text-3xl ${activeIcon === "home" ? "text-blue-500" : "text-gray-500"}`}>
            home
          </span>
        </Link>
      )}

      {/* Entries Icon */}
      {role !== "associated user" && (
        <Link to="/entries" onClick={() => handleIconClick("edit_note")} className="relative group">
          <span className={`material-symbols-rounded text-3xl ${activeIcon === "edit_note" ? "text-blue-500" : "text-gray-500"}`}>
            edit_note
          </span>
        </Link>
      )}

      {/* View Entries Icon */}
      <Link to="/view-entries" onClick={() => handleIconClick("insights")} className="relative group">
        <span className={`material-symbols-rounded text-3xl ${activeIcon === "insights" ? "text-blue-500" : "text-gray-500"}`}>
          insights
        </span>
      </Link>

      {/* Balance Icon */}
      <Link to="/balance" onClick={() => handleIconClick("account_balance_wallet")} className="relative group">
        <span className={`material-symbols-rounded text-3xl ${activeIcon === "account_balance_wallet" ? "text-blue-500" : "text-gray-500"}`}>
          account_balance_wallet
        </span>
      </Link>
    </div>
  );
}

export default BottomBar;
